///////////////////////////////
// Description
///////////////////////////////

	// See config/standard_database_endpoints for documentation

///////////////////////////////
// Imports
///////////////////////////////

import {
	collection,
	CollectionReference,
	doc,
	DocumentData,
	DocumentReference,
	getFirestore,
	Query
} from 'firebase/firestore'
import {
	generateDatabaseQuery,
	TsInterface_OrderByArray,
	TsInterface_QueryOperatorsArray
} from 'rfbp_core/services/database_management'
import {
	TsType_String,
	TsType_Unknown
} from 'rfbp_core/typescript/global_types'

///////////////////////////////
// Typescript
///////////////////////////////


///////////////////////////////
// Variables
///////////////////////////////

	// Displayed Translatable Strings


///////////////////////////////
// Functions
///////////////////////////////


///////////////////////////////
// Exports
///////////////////////////////

// Main
export const DatabaseRef_Tickets_Collection =
	( clientKey: TsType_String ): CollectionReference< DocumentData > => {
	return collection( getFirestore(), "clients", clientKey, "jobs", "tickets", "main" ) }

export const DatabaseRef_Ticket_Document =
	( clientKey: TsType_String, ticketKey: TsType_String ): DocumentReference< DocumentData > => {
	return doc( getFirestore(), "clients", clientKey, "jobs", "tickets", "main", ticketKey ) }

// Search By ID
export const DatabaseRef_TicketIDNumberSearch_Query =
	( clientKey: TsType_String, idNumber: TsType_String ): Query< TsType_Unknown > => {
	let queryOperatorsArray: TsInterface_QueryOperatorsArray = [ { prop: "id_number", comparator: "==", value: idNumber } ]
	let orderByArray: TsInterface_OrderByArray = []
	return generateDatabaseQuery( collection( getFirestore(), "clients", clientKey, "jobs", "tickets", "main" ), queryOperatorsArray, orderByArray, {}, null ) }

// Mini
export const DatabaseRef_TicketsMini_Collection =
	( clientKey: TsType_String ): CollectionReference< DocumentData > => {
	return collection( getFirestore(), "clients", clientKey, "jobs", "tickets", "mini" ) }

export const DatabaseRef_TicketMini_Document =
	( clientKey: TsType_String, ticketKey: TsType_String ): DocumentReference< DocumentData > => {
	return doc( getFirestore(), "clients", clientKey, "jobs", "tickets", "mini", ticketKey ) }

// Logs
export const DatabaseRef_TicketLog_Document =
	( clientKey: TsType_String, ticketKey: TsType_String, logKey: TsType_String ): DocumentReference< DocumentData > => {
	return doc( getFirestore(), "clients", clientKey, "jobs", "tickets", "log", ticketKey, "logs", logKey ) }


